import { Popover, Portal } from "@headlessui/react";
import { useState } from "react";
import { IconType } from "react-icons";
import { FiMoreVertical } from "react-icons/fi";

export interface RowAction {
  label: string;
  icon?: IconType;
  onClick: () => void;
  className?: string;
}

const RowActionsMenu = ({
  actions,
  ariaLabel = "Abrir ações",
}: {
  actions: RowAction[];
  ariaLabel?: string;
}) => {
  const [panelPosition, setPanelPosition] = useState<{ top: number; left: number } | null>(null);

  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <Popover.Button
            type="button"
            className="rounded-md p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-900"
            aria-label={ariaLabel}
            onClick={(event) => {
              const rect = event.currentTarget.getBoundingClientRect();
              setPanelPosition({
                top: rect.bottom + 4,
                left: Math.max(8, rect.right - 144),
              });
            }}
          >
            <FiMoreVertical size={18} />
          </Popover.Button>
          {open && panelPosition && (
            <Portal>
              <Popover.Panel
                static
                className="fixed z-[9999] w-36 rounded-lg bg-white p-1 text-left shadow-lg ring-1 ring-black/5"
                style={{ top: panelPosition.top, left: panelPosition.left }}
              >
                {actions.map((action) => (
                  <button
                    key={action.label}
                    type="button"
                    className={
                      action.className ??
                      "flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    }
                    onClick={action.onClick}
                  >
                    {action.icon && <action.icon size={16} />}
                    {action.label}
                  </button>
                ))}
              </Popover.Panel>
            </Portal>
          )}
        </>
      )}
    </Popover>
  );
};

export default RowActionsMenu;
